import { flattenMenuTree } from "./treeUtils";
import { normaliseRoutePath } from "./routePath";

// These pages are intentionally available before the permission tree loads.
// Keep this list aligned with the enterprise router's existing public routes.
const PUBLIC_PATHS = [
  "/Login",
  "/404",
  "/403",
  "/500",
  "/yanzhengma",
  "/getCode",
  "/resetPassword",
  "/sceneSelect",
  "/upgradeStatus",
  "/centerHtml",
];

function hasStaticRoutePath(routes, path) {
  return flattenMenuTree(routes).some(function(route) {
    return route && route.path === path;
  });
}

function hasMenuRoutePath(menuTree, path) {
  return flattenMenuTree(menuTree).some(function(menu) {
    const menuPath = normaliseRoutePath(menu && menu.path);

    if (!menu || menuPath !== path || menuPath === "/Layout") {
      return false;
    }

    return menu.isContainer || menu.isAuthorized;
  });
}

function hasKnownMenuPath(paths, path) {
  return Array.isArray(paths) && paths.indexOf(path) !== -1;
}

export function isPublicPath(path) {
  return PUBLIC_PATHS.indexOf(path) !== -1;
}

export function getKnownMenuPaths(menuList) {
  const paths = [];
  const seenPaths = Object.create(null);

  (Array.isArray(menuList) ? menuList : []).forEach(function(menu) {
    const path = normaliseRoutePath(menu && menu.url);

    if (!path || path === "/Layout" || seenPaths[path]) {
      return;
    }

    seenPaths[path] = true;
    paths.push(path);
  });

  return paths;
}

/**
 * Returns -1 for a routable URL; otherwise 403 (known but unauthorised) or
 * 404 (not present in backend menus or static route records).
 */
export function getRouteCode(path, staticRoutes, menuTree, knownMenuPaths) {
  if (hasMenuRoutePath(menuTree, path)) {
    return -1;
  }

  // Local static pages retain historic default access, including old add,
  // detail and edit routes that still have matching backend menu records.
  if (hasStaticRoutePath(staticRoutes, path)) {
    return -1;
  }

  if (hasKnownMenuPath(knownMenuPaths, path)) {
    return 403;
  }

  return hasStaticRoutePath(staticRoutes, path) ? -1 : 404;
}

export default {
  getKnownMenuPaths: getKnownMenuPaths,
  getRouteCode: getRouteCode,
  isPublicPath: isPublicPath,
};
